<a class="biblio-card" [routerLink]="['/index-details', item.id]">
  <article class="biblio-card__inner">
    <div class="biblio-card__media">
      @if (item.coverImageUrl && !imageFailed) {
        <img
          class="biblio-card__image"
          [src]="item.coverImageUrl"
          alt=""
          aria-hidden="true"
          loading="lazy"
          (error)="onImageError()"
        />
      } @else {
        <div class="biblio-card__cover" [attr.data-variant]="coverVariant" aria-hidden="true">
          <span class="biblio-card__cover-title">{{ formattedTitle }}</span>
        </div>
      }
    </div>

    <div class="biblio-card__content">
      <h3 class="biblio-card__title" [attr.title]="formattedTitle">{{ formattedTitle }}</h3>

      <div class="biblio-card__meta">
        <p class="biblio-card__meta-row">
          <img class="biblio-card__icon" src="images/custom/user-icon-black.svg" alt="" aria-hidden="true" />
          <span class="biblio-card__meta-text">{{ item.author || '—' }}</span>
        </p>

        <p class="biblio-card__meta-row">
          <img class="biblio-card__icon" src="images/custom/date-icon-black.svg" alt="" aria-hidden="true" />
          <span class="biblio-card__meta-text">{{ item.hijriDate || '—' }}</span>
        </p>
      </div>
    </div>
  </article>
</a>
